module.exports = __webpack_public_path__ + "files/972c97d942d542a6625cded283fd81db.mp3";